import loadable from '@loadable/component';
export const manifest = {
  BottomSheet: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "BottomSheetMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "BottomSheetMobile", webpackPrefetch: true */
          './bottom-sheet-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./bottom-sheet-mobile");
            }

            return eval('require.resolve')("./bottom-sheet-mobile");
          }

        }, {
          resolveComponent: m => m.BottomSheetMobile
        })
      }
    }
  },
  'BottomSheet.SwipeTrigger': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "BottomSheetSwipeTriggerMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "BottomSheetSwipeTriggerMobile", webpackPrefetch: true */
          './swipe-trigger-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./swipe-trigger-mobile");
            }

            return eval('require.resolve')("./swipe-trigger-mobile");
          }

        }, {
          resolveComponent: m => m.BottomSheetSwipeTriggerMobile
        })
      }
    }
  }
};